import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { Form, Button, Table } from "react-bootstrap";
import { TitleHeading } from "../UIElements/headings/TitleHeading";
import styles from '../listings/forms/addpost.module.css';
import style from '../UIElements/Form_label/FormLabels.module.css'
import sty from './martcard.module.css'
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import { notifyUser, type } from '../utility/notifyUser';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import { FileInput } from "../UIElements/input/FileInput";
import { address, zipCode, personName, webSiteDomain } from '../RegxConst'
import ReactPaginate from 'react-paginate';
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';


const ProductInventory = (props, selectedProduct) => {
    const { id } = useParams(); // Mart ID from URL
    const [showForm, setShowForm] = useState(false); // Toggle form visibility
    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [productImages, setProductImage] = useState(null);
    const history = useHistory();
    const [webSite, setWebSite] = useState('');
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(1);
    const [availableFrom, setAvailableFrom] = useState(null);
    const [availableTo, setAvailableTo] = useState(null);
    const [formData, setFormData] = useState({
        id: null,
        martId: null,
        productName: "",
        productDescription: "",
        productCategory: "",
        sizeStockPrices: [{ size: "", stockQuantity: "", productPrice: 0 }],
        gstPercentage: null,
        productImages: [],
        imageFields: [""],  // Stores input fields
        webSite: '',
    });

    const fetchProducts = async (page = 0) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/v2/get-by-mart/${id}?page=${page}`);
            if (response.status === 200) {
                setProducts(response.data.data);
                setCurrentPage(page);
                setPageCount(response.data.pageCount || 1);
            } else {
                alert("Failed to fetch product data.");
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        fetchProducts(selectedPage); // fetch products for that page
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProducts(0);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prevErrors) => ({
            ...prevErrors,
            webSite: webSiteDomain.test(formData.webSite) || formData.webSite === '' ? '' : 'Website is not valid!',
        }));

        setWebSite(value);
    };

    const handleSizeChange = (index, field, value) => {
        const updatedSizes = [...formData.sizeStockPrices];
        updatedSizes[index][field] = value;
        setFormData({ ...formData, sizeStockPrices: updatedSizes });
    };

    const areAllSizesFilled = () => {
        return formData.sizeStockPrices.every(entry =>
            entry.size.trim() !== "" &&
            entry.stockQuantity !== "" &&
            entry.productPrice !== 0
        );
    };

    const addSizeEntry = () => {
        if (areAllSizesFilled()) {
            setFormData({
                ...formData,
                sizeStockPrices: [...formData.sizeStockPrices, { size: "", stockQuantity: "", productPrice: 0 }]
            });
        }
    };

    const handleImageUpload = async (file, index) => {
        if (!file || !file.type.startsWith("image")) {
            notifyUser("Invalid File", "Please select a valid image file", "warning");
            return;
        }

        const formDataUpload = new FormData();
        formDataUpload.append("photo", file);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/abmgr/user/upload-pan-card`,
                formDataUpload
            );

            if (response.status === 200 && response.data) {
                const uploadedImageName = response.data; // Get the new image name

                setFormData((prev) => {
                    const updatedImages = [...prev.productImages];
                    updatedImages[index] = {
                        name: uploadedImageName,
                        url: `${process.env.REACT_APP_IMAGES_URL}/${uploadedImageName}`
                    };

                    return { ...prev, productImages: updatedImages };
                });

                // **Force refresh product data from backend**
                fetchProducts(0);

                notifyUser("Success", "Image uploaded successfully", "success");
            } else {
                notifyUser("Error", "Invalid image name received", "danger");
            }
        } catch (error) {
            console.error("Error uploading image:", error);
            notifyUser("Error", "Failed to upload image", "danger");
        }
    };


    const addImageField = () => {
        setFormData((prev) => ({
            ...prev,
            productImages: [
                ...prev.productImages,
                { name: "", url: "" }
            ]
        }));
    };

    const removeImage = (index) => {
        setFormData((prev) => {
            const updatedImages = prev.productImages.filter((_, i) => i !== index);

            return {
                ...prev,
                productImages: updatedImages
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const nonEmptyImages = formData.productImages.filter(img => img.name && img.name.trim() !== "")
        const ProductDTO = {
            ...formData,
            martId: Number(id),
            id: currentProduct ? currentProduct.id : null,
            sizeStockPrices: formData.sizeStockPrices.map(entry => ({
                size: entry.size.trim(),
                stockQuantity: Number(entry.stockQuantity),
                productPrice: entry.productPrice
            })),
            // productImages: formData.productImages
            //     .filter(entry => entry.name && entry.name.trim() !== "")
            //     .map(entry => entry.name),
            productImages: nonEmptyImages.map(entry => entry.name),
            webSite: formData.webSite,
            gstPercentage: String(formData.gstPercentage),
            availableFrom: availableFrom,
            availableTo: availableTo
        };

        try {
            if (currentProduct) {
                if (nonEmptyImages.length === 0) {
                    notifyUser("Error", "Please Add Product Image", "warning");
                } else {
                    await axios.put(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/update/${currentProduct.id}`, ProductDTO);
                    notifyUser("Success", "Product updated successfully", "success");
                    setFormData(prev => ({
                        ...prev,
                        productImages: prev.productImages.filter(entry => entry.name && entry.name.trim() !== "")
                    }));

                    setShowForm(false);
                    await fetchProducts(0);
                }
            } else {
                // const nonEmptyImages = formData.productImages.filter(img => img.name && img.name.trim() !== "")
                if (nonEmptyImages.length === 0) {
                    notifyUser("Error", "Please Add Product Image", "warning");
                } else {
                    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/add`, ProductDTO);
                    notifyUser("Success", "Product added successfully", "success");
                    setFormData(prev => ({
                        ...prev,
                        productImages: prev.productImages.filter(entry => entry.name && entry.name.trim() !== "")
                    }));

                    setShowForm(false);
                    fetchProducts(0);
                }
            }
        } catch (error) {
            console.error("Error updating product:", error);
            notifyUser("Error", "Failed to update product", "danger");
        }
    };

    const handleProductMart = async (product = null) => {
        setCurrentProduct(product);
        setShowForm(true);

        if (product) {
            await fetchProducts(0);
            setFormData({
                productName: product.productName || '',
                productDescription: product.productDescription || '',
                productCategory: product.productCategory || '',
                gstPercentage: String(product.gstPercentage) || null,
                sizeStockPrices: (product.sizeStockPrices && product.sizeStockPrices.length > 0)
                    ? product.sizeStockPrices.map(entry => ({
                        size: entry.size.trim(),
                        stockQuantity: Number(entry.stockQuantity),
                        productPrice: entry.productPrice
                    }))
                    : [{ size: "", stockQuantity: "", productPrice: 0 }],

                productImages: (product.productImages && product.productImages.length > 0)
                    ? product.productImages.map(img => ({
                        name: img,
                        url: process.env.REACT_APP_IMAGES_URL + '/' + img
                    }))
                    : [],
                webSite: product.webSite || null
            });
            setAvailableFrom(product.availableFrom || null);
            setAvailableTo(product.availableTo || null);
        } else {
            setFormData({
                productName: '',
                productDescription: '',
                gstPercentage: null,
                productCategory: '',
                sizeStockPrices: [{ size: "", stockQuantity: "", productPrice: 0 }],
                productImages: [],
                webSite: '',
            });
        }
    };

    const handleGstInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "gstPercentage" ? parseFloat(value) : value
        }));
    };



    const handleDelete = async (productId, size) => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/remove/${productId}/${size}`);
            notifyUser("Success", "Product deleted successfully", "success");

            // setProducts(prevProducts => prevProducts.filter(product => product.id !== productId));
            setProducts(prevProducts =>
                prevProducts.map(product => {
                    if (product.id === productId) {
                        const updatedSizes = product.sizeStockPrices.filter(entry => entry.size !== size);

                        // If no sizes left, remove the product entirely
                        if (updatedSizes.length === 0) {
                            return null;
                        }

                        return {
                            ...product,
                            sizeStockPrices: updatedSizes
                        };
                    }
                    return product;
                }).filter(Boolean) // remove null entries (i.e. products with 0 sizes)
            );
        } catch (error) {
            console.error("Error deleting product:", error);
            notifyUser("Error", "Failed to delete product", "danger");
        }
    };

    const handleRemoveSizeEntry = (index) => {
        const updatedSizes = formData.sizeStockPrices.filter((_, i) => i !== index);
        setFormData({ ...formData, sizeStockPrices: updatedSizes });
    };

    const handleWebLink = (value) => {
        setErrors((prevErrors) => ({
            ...prevErrors,
            webSite: webSiteDomain.test(value) || value === '' ? '' : 'Website is not valid!',
        }));

        setWebSite(value);
    };


    // const loadCategoryOptions = async (inputValue, callback) => {
    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/categories/suggest/${id}?q=${inputValue}`
    //         );

    //         const options = response.data.map((category) => ({
    //             label: category,
    //             value: category
    //         }));

    //         callback(options);
    //     } catch (error) {
    //         console.error("Error fetching categories:", error);
    //         callback([]);
    //     }
    // };

    const loadCategoryOptions = async (inputValue, callback) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/categories/suggest/${id}?q=${inputValue}`
            );

            let options = response.data.map((category) => ({
                label: category,
                value: category
            }));

            // Check if typed input is not already in the options
            const inputExists = options.some(opt => opt.value.toLowerCase() === inputValue.toLowerCase());

            // If input doesn't exist, add it as an option
            if (inputValue && !inputExists) {
                options = [
                    { label: `${inputValue}`, value: inputValue },
                    ...options,
                ];
            }

            callback(options);
        } catch (error) {
            console.error("Error fetching categories:", error);
            callback(inputValue ? [{ label: `Use "${inputValue}"`, value: inputValue }] : []);
        }
    };



    let rowIndex = currentPage * 15;

    return (
        <div className="admin-view-head">
            <div className="mt-4 g-2 col-md-12">
                <div className="col-md-2 add_button animated_back_button text-right">
                    <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                        handleClick={() => props.history.goBack()}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
                </div>
                <TitleHeading text='Inventory Management' />
                {!showForm ? (
                    <Button className="secondary" variant="primary" onClick={() => handleProductMart(null)}>Add New Product</Button>
                ) : (
                    <div>
                        <Button variant="danger" className="popup-close-btn" onClick={() => setShowForm(false)}>
                            &times;
                        </Button>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Product Name*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control type="text" name="productName" value={formData.productName} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Description*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control as="textarea" name="productDescription" value={formData.productDescription} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group>
                            {/* <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Category*</Form.Label></div>
                                    <div className='col-md-10'>
                                        <Form.Control type="text" name="productCategory" value={formData.productCategory} onChange={handleInputChange} required />
                                    </div>
                                </div>
                            </Form.Group> */}

                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                        <Form.Label>Category*</Form.Label>
                                    </div>
                                    <div className='col-md-10'>
                                        <AsyncCreatableSelect
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={loadCategoryOptions}
                                            onChange={(selectedOption) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    productCategory: selectedOption ? selectedOption.value : '',
                                                }));
                                            }}
                                            onInputChange={(inputValue, actionMeta) => {
                                                // When user types but doesn't select, keep it in formData
                                                if (actionMeta.action === 'input-change') {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        productCategory: inputValue,
                                                    }));
                                                }
                                            }}
                                            onCreateOption={(inputValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    productCategory: inputValue,
                                                }));
                                            }}
                                            value={
                                                formData.productCategory
                                                    ? { label: formData.productCategory, value: formData.productCategory }
                                                    : null
                                            }
                                            placeholder="Type or select category"
                                            isClearable
                                        />

                                    </div>
                                </div>
                            </Form.Group>


                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Size, Stock & Price*</Form.Label></div>
                                    <div className='col-md-10'>
                                        {formData.sizeStockPrices.map((entry, index) => (
                                            <div key={index}>
                                                <Form.Control type="text" placeholder="Size" value={entry.size} onChange={(e) => handleSizeChange(index, "size", e.target.value)} required />
                                                <Form.Control type="number" placeholder="Stock" value={entry.stockQuantity} onChange={(e) => handleSizeChange(index, "stockQuantity", e.target.value)} required />
                                                <Form.Control type="number" placeholder="Price" value={entry.productPrice} onChange={(e) => handleSizeChange(index, "productPrice", e.target.value)} required />

                                                <Button
                                                    variant="danger"
                                                    className={`p-2 ${sty.addbtn}`}
                                                    onClick={() => handleRemoveSizeEntry(index)}
                                                >
                                                    🗑️
                                                </Button>
                                            </div>
                                        ))}
                                        <Button
                                            variant="secondary"
                                            onClick={addSizeEntry}
                                            disabled={!areAllSizesFilled()}
                                            className={`mt-2 ${sty.addbtn}`}
                                        >
                                            Add More Sizes
                                        </Button></div>
                                </div>

                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                        <Form.Label>GST Percentage*</Form.Label>
                                    </div>
                                    <div className='col-md-10'>
                                        <div className="input-group">
                                            <Form.Control
                                                as="select"
                                                name="gstPercentage"
                                                value={String(formData.gstPercentage)}
                                                onChange={handleGstInputChange}
                                                required
                                            >
                                                <option value="">Select GST</option>
                                                <option value={0}>0</option>
                                                <option value={5}>5</option>
                                                <option value={12}>12</option>
                                                <option value={18}>18</option>
                                                <option value={28}>28</option>
                                            </Form.Control>
                                            <div className="input-group-append">
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form.Group>

                            <div className='row col-md-10 p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Product Available Time</Form.Label></div>
                                <div className="col-md-10 justify-content-center mt-1">
                                    {/* <label className="col-md-2 text-md-right text-left">{day.charAt(0).toUpperCase() + day.slice(1)}</label> */}
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        minuteStep={1}
                                        value={availableFrom ? moment(availableFrom, 'hh:mm A') : null}
                                        onChange={(time, timeString) => setAvailableFrom(timeString)} // ✅ Add this
                                        placeholder="From"
                                        defaultOpenValue={moment('12:00 AM', 'hh:mm A')}
                                    />
                                    &nbsp;&nbsp;
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        minuteStep={1}
                                        value={availableTo ? moment(availableTo, 'hh:mm A') : null}
                                        onChange={(time, timeString) => setAvailableTo(timeString)} // ✅ Add this
                                        placeholder="To"
                                        defaultOpenValue={moment('12:00 AM', 'hh:mm A')}
                                    />

                                    {errors.time && <p style={{ color: 'red', marginTop: '5px' }}>{errors.time}</p>}
                                </div>
                            </div>



                            <Form.Group>
                                <div className='row col-md-10 p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}> <Form.Label>Product Images*</Form.Label></div>
                                    <div className='col-md-10 justify-content-center'>

                                        {formData.productImages.map((imageObj, index) => (
                                            <>
                                                <div key={index} style={{ position: "relative", marginBottom: "10px", display: "flex", }}>
                                                    <FileInput
                                                        file_url={imageObj.url || ""}
                                                        file={null} // Prevent default file input from being pre-filled
                                                        file_name={imageObj.name || ""}
                                                        disabled={false}
                                                        onFileSelect={(e) => handleImageUpload(e.target.files[0], index)}
                                                        fileFormats=".png, .jpg, .jpeg, .gif"
                                                        labelText={'Choose Image'}
                                                    />
                                                </div>
                                                {imageObj.name && (
                                                    <div className={sty.image_container}>
                                                        <img src={`${process.env.REACT_APP_IMAGES_URL}/${imageObj.name}`} alt="Product Image" className={sty.preview_image} />
                                                        <button type="button" className={sty.cancel_btn} onClick={() => removeImage(index)}>&times;</button>
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}></div>
                                    <div className="col-md-10">
                                        <Button
                                            variant="secondary"
                                            onClick={addImageField}
                                            className={`mt-2 ${sty.addbtn}`}
                                            disabled={formData.productImages.length >= 5} // Limit to 5 images
                                        >
                                            Add Photo
                                        </Button>
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group>
                                <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                    <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label> Product Detail </Form.Label></div>
                                    <div className="col-md-10">
                                        <input type="text" className={`form-control`}
                                            placeholder={'Enter URL'}
                                            name="webSite" value={formData.webSite}
                                            onChange={handleInputChange}
                                            noValidate />
                                        {/* {(this.state.showWWW || this.state.webSite.length > 0) ? <label className={`${styles.website_prefix_label}`}></label> : null} */}
                                        <p>{errors.webSite}</p>
                                    </div>
                                </div>
                            </Form.Group>
                            <div className="popup-buttons">
                                <Button className="secondary" variant="danger" onClick={() => setShowForm(false)}>Cancel</Button>
                                <Button className="secondary" variant="primary" type="submit">Submit</Button>
                            </div>
                        </Form>
                    </div>
                )}
                {!showForm && (
                    <div className="table-responsive"> {/* Enables responsiveness */}
                        <Table striped bordered hover className="mt-4">
                            <thead>
                                <tr>
                                    <th>S.no.</th>
                                    <th>Product Name</th>
                                    <th>Category</th>
                                    <th>Size</th>
                                    <th>Stock</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.flatMap((product, productIndex) => {
                                    const globalProductIndex = currentPage * 15 + productIndex + 1
                                    return product.sizeStockPrices.map((sizeEntry, sizeIndex) => (
                                        <tr key={`${productIndex}-${sizeIndex}`}>
                                            <td>{globalProductIndex}.{sizeIndex + 1}</td>
                                            <td>{product.productName}</td>
                                            <td>{product.productCategory}</td>
                                            <td>{sizeEntry.size}</td>
                                            <td>{sizeEntry.stockQuantity}</td>
                                            <td>₹{sizeEntry.productPrice}</td>
                                            <td>{product.status}</td>
                                            <td>
                                                <Button variant="warning" onClick={() => handleProductMart(product)}>
                                                    ✏️
                                                </Button>
                                            </td>
                                            <td>
                                                <Button className="delete-icon" variant="warning" onClick={() => handleDelete(product.id, sizeEntry.size)}>
                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                })}
                            </tbody>

                        </Table>
                        {pageCount > 1 && (
                            <div className="pagination-container text-center">
                                <ReactPaginate
                                    previousLabel={"← Prev"}
                                    nextLabel={"Next →"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination justify-content-center"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={currentPage}
                                    disabledClassName="pagination_disable_next_prev"
                                />
                            </div>
                        )}
                    </div>

                )}
            </div>
            <br></br>
            <div className={`listings row ${styles.large_rect}`}>
                {!props.isAdmin && <LargeRectangle spot={"-1"} />}
            </div>
            <div className={`${styles.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                {!props.isAdmin && <BillBoard spot={"-1"} />}
            </div>
        </div>
    );
};

export default ProductInventory;
